import { render } from "./testbuilderdetaileditor.vue?vue&type=template&id=9f4de792&scoped=true"
import script from "./testbuilderdetaileditor.vue?vue&type=script&lang=js"
export * from "./testbuilderdetaileditor.vue?vue&type=script&lang=js"

import "./testbuilderdetaileditor.vue?vue&type=style&index=0&id=9f4de792&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f4de792"]])

export default __exports__